export default __webpack_public_path__ + "static/media/youtube.d1cfc843.png";